import { render, staticRenderFns } from "./_tournamentJackpot.vue?vue&type=template&id=8ccf56a4&lang=pug&"
import script from "./_tournamentJackpot.vue?vue&type=script&lang=js&"
export * from "./_tournamentJackpot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports